module.exports = __webpack_public_path__ + "static/media/external-link.e4c628b6.svg";